var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.78,
    height: 26.23,
    viewBox: "0 0 14.78 26.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "temperature-full",
    d: "M24.211,16.571V5.748a.821.821,0,1,0-1.642,0V16.571a2.463,2.463,0,1,0,1.642,0Zm4.927-2.279V5.748A5.737,5.737,0,0,0,23.436,0a5.816,5.816,0,0,0-5.794,5.748v8.545a7.39,7.39,0,1,0,11.5,0Zm-5.748,8.7a4.066,4.066,0,0,1-2.463-7.331V5.792a2.463,2.463,0,0,1,4.927,0V15.66a4.066,4.066,0,0,1-2.463,7.331Z",
    transform: "translate(-16)",
    fill: "#74788d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.ae2caf9d.svg";
export { ForwardRef as ReactComponent };